import { jsx as r, jsxs as o } from "react/jsx-runtime";
import { useId as C, useState as D, useMemo as h, useCallback as P } from "react";
import { chakra as I, useMultiStyleConfig as M, Flex as d, Box as p } from "@chakra-ui/react";
import $ from "react-paginate";
import { SelectBase as j } from "../../forms/Select/SelectBase.mjs";
import { NextLabel as x, PreviousLabel as N } from "./PaginationComponents.mjs";
import { combineClasses as k } from "../../../utils/combineClasses.mjs";
const F = $.default ? $.default : $, O = ({ ...n }) => /* @__PURE__ */ r(F, { ...n }), R = I(O, {
  shouldForwardProp: () => !0
}), _ = [10, 25, 50, 100], W = (n, c, i) => {
  let t = "";
  return i === 0 ? t = "0" : (t = `${n + 1}-`, i < n + c ? t += i : t += n + c), `${t} `;
}, K = ({
  className: n,
  id: c,
  onPageChange: i,
  onPageSizeChange: t,
  pageSize: a = _[0],
  pageSizeOptions: v = _,
  totalCount: l,
  ...y
}) => {
  const e = "gravity-pagination", m = c || C(), u = M("Pagination"), [g, b] = D(0), f = h(() => Math.ceil(l / a), [a, l]), L = h(() => a * g, [a, g]), B = P(
    (s) => {
      const A = s.selected * a % l;
      b(s.selected), i(s, A);
    },
    [i, a, l]
  ), w = P(
    (s) => {
      b(0), t(s, Number(s.target.value), 0);
    },
    [t]
  );
  return /* @__PURE__ */ o(
    d,
    {
      sx: u.paginationContainer,
      id: `${e}-${m}`,
      className: k(`${e}`, n),
      ...y,
      children: [
        /* @__PURE__ */ o(d, { sx: u.paginationSize, className: `${e}__pagesize`, children: [
          /* @__PURE__ */ r(p, { id: `${e}--pagesizelabel-${m}`, className: `${e}__pagesizelabel`, children: "Show per page" }),
          /* @__PURE__ */ r(
            j,
            {
              id: `${e}--pagesizeselect-${m}`,
              name: `${e}--pagesizeselect-${m}`,
              className: `${e}__pagesizeselect`,
              value: a.toString(),
              onChange: w,
              size: "sm",
              "aria-labelledby": `${e}--pagesizelabel-${m}`,
              maxW: "75px",
              children: v.map((s) => /* @__PURE__ */ r("option", { value: s, children: s }, s))
            }
          )
        ] }),
        /* @__PURE__ */ o(d, { sx: u.paginationButtons, className: `${e}__controls`, children: [
          /* @__PURE__ */ o(p, { role: "status", "aria-live": "polite", children: [
            W(L, a, l),
            /* @__PURE__ */ o(p, { as: "span", color: "gray.600", children: [
              "of ",
              l
            ] })
          ] }),
          /* @__PURE__ */ r(
            R,
            {
              sx: u.paginationBase,
              className: `${e}__pagebuttons`,
              nextLabel: /* @__PURE__ */ r(x, {}),
              previousLabel: /* @__PURE__ */ r(N, {}),
              pageCount: f,
              onPageChange: B,
              ...f > 0 && { forcePage: g },
              renderOnZeroPageCount: () => /* @__PURE__ */ o(d, { gap: 2, children: [
                /* @__PURE__ */ r(N, { isDisabled: !0 }),
                /* @__PURE__ */ r(x, { isDisabled: !0 })
              ] }),
              nextAriaLabel: `Next ${a} items`,
              previousAriaLabel: `Previous ${a} items`
            }
          )
        ] })
      ]
    }
  );
};
export {
  K as Pagination,
  _ as defaultPaginationSizeOptions
};
